import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Presentation as PresentationIcon } from 'lucide-react'

import { toast } from 'components/ui/toast-store'
import { cn } from 'lib/utils'

import { isPresentationsEnabled, presentationEditPath } from '../featureFlag'
import { PortfolioDeckDialog } from './PortfolioDeckDialog'

/**
 * "Create presentation" on a Portfolio page (MYD-507): a review deck of the
 * portfolio's overview and each of its locations, opened in the editor.
 * Renders nothing when Presentations is switched off.
 */
interface PortfolioPresentationButtonProps {
	portfolio: { entityId: string; name: string } | null
	className?: string
}

export function PortfolioPresentationButton({ portfolio, className }: PortfolioPresentationButtonProps) {
	const navigate = useNavigate()
	const [open, setOpen] = useState(false)
	if (!isPresentationsEnabled() || !portfolio) return null

	return (
		<>
			<button
				type="button"
				onClick={() => setOpen(true)}
				className={cn(
					'inline-flex items-center gap-1.5 rounded-full border border-gray-200 px-3 py-1 text-xs font-medium text-gray-700 transition-colors hover:bg-gray-50',
					className,
				)}
			>
				<PresentationIcon className="h-3.5 w-3.5 text-primary" />
				Create presentation
			</button>
			<PortfolioDeckDialog
				open={open}
				mode={{ kind: 'create', portfolio }}
				onClose={() => setOpen(false)}
				onCreated={(presentation, dropped) => {
					setOpen(false)
					if (dropped > 0) toast.info(`${dropped} ${dropped === 1 ? 'element was' : 'elements were'} left out: they show data you do not have access to.`)
					navigate(presentationEditPath(presentation.id))
				}}
			/>
		</>
	)
}

export default PortfolioPresentationButton
